import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@/app/model/store';

import { notificationAdapter } from './notificationSlice';

export const selectNotification = notificationAdapter.getSelectors(
  (state: RootState) => state.notification.notification,
);

export const selectNotificationStatus = createSelector(
  (state: RootState) => state.notification.notificationStatus,
  (notificationStatus) => notificationStatus,
);
